import React from 'react';
import './NavStrip.scss';

export const NavStrip = ({ dataLocale, redisCommonData }) => {
  const {
    FREE_SHIPPING,
    ONE_YEAR_WARRANTY,
    FREE_30_DAY_RETURN_OR_EXCHANGE,
    TOLL_FREE_NUMBER_TEXT,
    UAE_TIME_TEXT,
  } = dataLocale;
  const { SHOW_TOLL_NUMBER } = redisCommonData;
  const { enable, number } = JSON.parse(SHOW_TOLL_NUMBER);
  return (
    <div className="strip-container">
      <div className="strip-left">
        {FREE_SHIPPING} | {ONE_YEAR_WARRANTY}| {FREE_30_DAY_RETURN_OR_EXCHANGE}
      </div>
      {enable && (
        <div className="strip-right">
          {TOLL_FREE_NUMBER_TEXT} - {number} ({UAE_TIME_TEXT}){' '}
        </div>
      )}
    </div>
  );
};
